<template lang="pug">
  div(
    class="templates-dynamic-image"
    :class="imageWrapperClasses"
    @click="openFileInput"
  )
    ValidationProvider(
      v-if="!canEdit"
      :rules="rules"
      v-slot="{ errors }"
    )
      v-file-input(
        v-show="false"
        ref="fileInput"
        type="file"
        :accept="accept"
        @change="selectImage($event)"
      )
    div(
      v-if="image"
      class="templates-dynamic-image__image"
      :style="imageStyle"
    )
      img(:src="image")
    div(
      v-else
      class="templates-dynamic-image__wrapper"
    )
      e-svg-icon(
        v-if="!isPlaceholderEdit"
        :name="!canEdit ? 'image-primary' : 'image'"
        size="sm"
      )
      span(
        v-if="!isPlaceholderEdit"
        class="pt-1"
        :style="placeholderStyles"
      ) {{ placeholder }}
      textarea(
        v-model="placeholderValue"
        class="templates-dynamic-image__placeholder-textarea text-10px"
        placeholder="Вкажіть назву поля"
        :disabled="isDraggable || isResizing"
        @focus="onPlaceholderFocus"
        @blur="onPlaceholderBlur"
      )
</template>

<script>
import contentDialog from '~/mixins/dialogs/contentDialog'

export default {
  name: 'TemplatesDynamicImage',
  mixins: [contentDialog],
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: null
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    fontSize: {
      type: [String, Number],
      default: null
    },
    isResizing: {
      type: Boolean,
      default: false
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: null
    },
    isDraggable: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isPlaceholderEdit: false,
      placeholderValue: ''
    }
  },
  computed: {
    accept() {
      return 'image/png,image/jpg,image/jpeg'
    },
    validationAccept() {
      return 'jpg,jpeg,png'
    },
    rules() {
      const rules = 'image|size:1000|ext:'

      return rules + this.validationAccept
    },
    image() {
      const prefix = 'data:image/png;base64,'
      const base64 = this.value
      if (this.field.documentFieldValue) {
        return prefix + this.field.documentFieldValue
      } else if (base64) {
        return prefix + base64
      }
      return null
    },
    placeholderStyles() {
      return {
        fontSize: this.fontSize + 'px'
      }
    },
    imageStyle() {
      return {
        width: this.field.width,
        height: this.field.height
      }
    },
    imageWrapperClasses() {
      return {
        filled: !this.canEdit,
        'error-state': this.hasError
      }
    }
  },
  mounted() {
    this.setImage()
  },
  methods: {
    onPlaceholderFocus(e) {
      if (!this.canEdit) {
        return
      }
      this.isPlaceholderEdit = true
    },
    onPlaceholderBlur(e) {
      this.isPlaceholderEdit = false
      if (this.placeholderValue.trim() === '') {
        this.placeholderValue = ''
        return
      }
      this.$emit('blur', this.placeholderValue)
      this.placeholderValue = ''
    },
    setImage() {
      if (this.field.documentFieldPreValue) {
        this.$emit('update:value', this.field.documentFieldPreValue)
      } else {
        this.$emit('update:value', this.field.documentFieldValue)
      }
    },
    openFileInput() {
      if (!this.canEdit) {
        this.$refs.fileInput.$refs.input.click()
      }
    },
    selectImage(imageFile) {
      const blob = URL.createObjectURL(imageFile)

      const reader = new FileReader()

      reader.onload = async event => {
        const image = await this.contentDialog.open({
          width: '512px',
          title: 'Check and confirm the photo',
          titleClass: 'title-32px fw-700 text-left mb-5',
          component: 'm-block-image-cropper',
          componentProps: {
            imageUrl: blob,
            imageType: this.getMimeType(event.target.result, imageFile.type)
          }
        })
        if (!image) {
          return
        }
        if (image.status === 'change') {
          URL.revokeObjectURL(blob)
          this.openFileInput()
          return
        }
        const base64String = image.dataUrl.split(',')[1]
        this.$emit('update:value', base64String)
      }
      reader.readAsArrayBuffer(imageFile)
    },
    getMimeType(file, fallback = null) {
      const byteArray = new Uint8Array(file).subarray(0, 4)
      let header = ''
      for (let i = 0; i < byteArray.length; i++) {
        header += byteArray[i].toString(16)
      }
      switch (header) {
        case '89504e47':
          return 'image/png'
        case 'ffd8ffe0':
        case 'ffd8ffe1':
        case 'ffd8ffe2':
        case 'ffd8ffe3':
        case 'ffd8ffe8':
          return 'image/jpeg'
        default:
          return fallback
      }
    }
  }
}
</script>

<style scoped lang="scss">
.templates-dynamic-image {
  width: 100%;
  height: 100%;
  border: 1px solid $primary;
  border-radius: 8px;
  background: $white;
  cursor: pointer;
  overflow: hidden;

  &.filled {
    background:
      linear-gradient(0deg, rgba(143, 37, 125, 0.12) 0%, rgba(143, 37, 125, 0.12)) 100%,
      rgba(255, 255, 255, 0.4);
    color: $primary;
  }

  &__image {
    border-radius: 8px;
    height: 100%;

    img {
      width: 100%;
      height: 100%;
      border-radius: 8px;
    }
  }

  &__wrapper {
    width: 100%;
    height: 100%;

    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6px;
  }

  &__placeholder-textarea {
    width: 100%;
    outline: none;
    resize: none;

    &::placeholder {
      text-align: center;
    }
  }
}
</style>
